import Cookies from "js-cookie";

import { config } from "shared/data";
import { detectAdBlock } from "shared/lib/ad-block";
import { gtag } from "shared/lib/gtag";

const getGAIdFromCookie = () => {
  const gaValue = Cookies.get("_ga");
  if (!gaValue) return null;

  // GA cookie format: GA1.1.1234567890.1234567890
  const parts = gaValue.split(".");
  if (parts.length >= 2) {
    return parts.slice(-2).join(".");
  }
  return null;
};

export const getGoogleAnalyticsClientId = async () =>
  (await getGAClientIdFromGTM(config.googleAnalytics.measurementId)) ?? getGAIdFromCookie() ?? "";

export function computeGACampaignKey(name: string, variant: string) {
  const skippedVariant = new Set(["0", "1"]);
  return skippedVariant.has(variant) ? name : `${name}-${variant}`;
}

let getGaClientIdFromGTMPromise: Promise<string | undefined>;
export async function getGAClientIdFromGTM(profileId: string) {
  if (getGaClientIdFromGTMPromise !== undefined) return getGaClientIdFromGTMPromise;
  const hasAdBlock = await detectAdBlock();
  getGaClientIdFromGTMPromise = hasAdBlock
    ? Promise.resolve(undefined)
    : new Promise<string | undefined>(resolve => {
        setTimeout(() => {
          resolve(undefined);
        }, 5000);
        gtag("get", profileId, "client_id", (clientId: string) => resolve(clientId));
      });
  return getGaClientIdFromGTMPromise;
}
